// Brand mark: Anubis balancing the scales of justice on his staff.
export function Logo({ className = "w-6 h-6" }) {
  return (
    <img src="/logo-mark.png" alt="Redemption Academy" className={`${className} object-contain`} draggable={false} />
  );
}

// Brand wordmark with a smaller trademark mark: Redemption Academy™
export function Wordmark({ className = "" }) {
  return (
    <span className={className}>
      Redemption Academy<sup className="text-[0.5em] font-sans font-normal tracking-normal ml-[0.1em] top-[-0.15em]">™</sup>
    </span>
  );
}

export default Logo;
